import {
  SignInCustomerRequestedAction,
  signInCustomerFailed,
  signInCustomerSucceeded
} from '@spa/lib/store/auth/authSlice';
import { SignInResponse, getSession, signIn } from 'next-auth/react';
import { call, put, select } from 'typed-redux-saga';
import { trackLoginError, trackSuccessfulLogin } from '@spa/components/register/register-tracking';
import { Session } from 'next-auth';
import generateActionId from '@spa/lib/generateActionId';
import selectSessionUserId from '@spa/lib/store/session/selectors/selectSessionUserId';

type Credentials = { username: string; password: string };

const signInCredentials = (credentials: Credentials): Promise<SignInResponse | undefined> =>
  signIn('credentialsProvider', { ...credentials, redirect: false });

function* signInCustomerSaga({
  payload: { actionId: requestedActionId, email, password }
}: SignInCustomerRequestedAction): Generator {
  let succeeded = true;
  const anonymousUserId: string = yield* select(selectSessionUserId);
  try {
    const signInResponse: SignInResponse | undefined = yield* call(signInCredentials, {
      username: email,
      password
    });

    if (signInResponse?.error) {
      trackLoginError(signInResponse.error, anonymousUserId);
      succeeded = false;
    } else {
      const updatedSession: Session | null = yield* call(getSession);
      if (updatedSession) {
        const userId: string = updatedSession.user.id;
        trackSuccessfulLogin(userId, anonymousUserId);
      } else {
        trackLoginError('Session could not be loaded', anonymousUserId);
        succeeded = false;
      }
    }
  } catch {
    succeeded = false;
  }

  const actionId: number = generateActionId();
  if (succeeded) {
    yield* put(
      signInCustomerSucceeded({
        actionId,
        requestedActionId
      })
    );
  } else {
    yield* put(
      signInCustomerFailed({
        actionId,
        requestedActionId
      })
    );
  }
}

export default signInCustomerSaga;
